import Clients from '@/views/client/Clients.vue'
import FormClient from '@/views/client/FormClient.vue'

const commonRouter = (beforeEnter, name, singleName, basePath, tabs, onlyManaged, options) => {
    const addRoute = `Cadastrar${singleName}`
    const addLabel = `Cadastrar ${singleName}`

    const editRoute = `Editar${singleName}`
    const editLabel = `Editar ${singleName}`

    return [
        {
            beforeEnter: beforeEnter,
            name: name,
            path: basePath,
            meta: {
                breadcrumb: true,
                breadcrumbName: name,
                add: {
                    route: addRoute,
                    label: addLabel
                },
                edit: {
                    route: editRoute,
                    label: editLabel
                },
                public: false,
                isEmployee: true,
                layout: 'default',
                singleName,
                onlyManaged,
                options
            },
            component: Clients
        },
        {
            beforeEnter: beforeEnter,
            name: addRoute,
            breadcrumb: addLabel,
            path: `${basePath}/cadastrar`,
            meta: {
                requiresAuth: true,
                isEmployee: true,
                breadcrumb: true,
                breadcrumbName: addLabel,
                layout: 'default'
            },
            component: FormClient
        },
        {
            beforeEnter: beforeEnter,
            name: editRoute,
            path: `${basePath}/editar/:id`,
            meta: {
                requiresAuth: true,
                isEmployee: true,
                breadcrumb: true,
                breadcrumbName: editLabel,
                layout: 'default'
            },
            component: FormClient
        }
    ]
}

export default commonRouter
